






















import { Component, Vue } from 'vue-property-decorator';
import MainNav from './views/shared/MainNav.vue';
import AdminNav from './views/shared/AdminNav.vue';
import GlobalFooter from './views/shared/GlobalFooter.vue';
import AgeVerification from './components/shared/AgeVerification.vue';

@Component({
  components: {
    MainNav,
    AdminNav,
    GlobalFooter,
    AgeVerification,
  },
})
export default class App extends Vue {
  private cookieCheck: boolean = false;
  private modalOpen: boolean = true;


  private created() {
    this.$nextTick(() => {
      if (document.cookie) {
        this.cookieCheck = true;
        this.modalOpen = false;
      }
    });
  }


  private modalOpenScript() {
    this.modalOpen = true;
  }

  private modalClosedScript() {
    this.modalOpen = false;
  }
}
